const baseUri = 'delivery-addresses';

export default {

  index(query, limit, cancelToken) {
    return api.get(baseUri, {
      params: {
        query,
        limit,
      },
      cancelToken,
    });
  },
};



// WEBPACK FOOTER //
// ./src/js/api/deliveryAddress.js